
@if (linkable) {
  <a
    [routerLink]="{ cxRoute: route, params: routeModel } | cxUrl"
    [tabIndex]="tabIndex"
    >
    <ng-container *ngTemplateOutlet="text"></ng-container>
  </a>
} @else {
  <span class="text" title="{{ property }}">{{ property | reverseUsername }}</span>
}

<ng-template #text>
  <span class="text" title="{{ property }}">{{ property | reverseUsername }}</span>
</ng-template>

